/**
 * useImageProtection — 防止使用者下載 host 自家渲染的圖片。
 *
 * # 三個攻擊面
 *
 *   - 桌機右鍵「另存圖片」→ 攔 `contextmenu`
 *   - 拖曳圖片到桌面存檔 → 攔 `dragstart`(補 CSS `-webkit-user-drag` 在非 webkit 的缺口)
 *   - 手機長按存圖 → 由 `src/style.css` 的 `img { -webkit-touch-callout: none }` 處理
 *
 * # 只擋 `<img>` 不擋其他元素
 *
 * 只在 `e.target instanceof HTMLImageElement` 才 preventDefault,讓:
 *   - 非圖片元素的右鍵 / 拖曳 / 選取行為照常
 *   - 跨網域 iframe(Cocos 遊戲 / shared-web 弹窗)內的圖**不受此規則影響**
 *
 * # App-lifetime listener
 *
 * 沒有 cleanup — 這兩個 listener 跟 host 同生共滅,在 mount 前由 main.ts 註冊一次,
 * `main.ts` 不會 unmount,所以不用 onBeforeUnmount。
 */

export function initImageProtection(): void {
  const blockImageSave = (e: Event): void => {
    if (e.target instanceof HTMLImageElement) e.preventDefault()
  }
  document.addEventListener('contextmenu', blockImageSave)
  document.addEventListener('dragstart', blockImageSave)
}
